import React, {useEffect, useState} from "react";
import {FieldPrefix, PrefixedError, PrefixedField} from "../fields/PrefixField";
import InputField from "../fields/InputField";
import {composeValidators, email, limit, required} from "../../helpers/ValidateHelper";
import PhoneFiled from "../fields/PhoneFiled";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import useIsMobile from "../../helpers/MobileHelper";

function RegisterForm({countryOptions}) {
    const {ipIsoCode} = useSelector(state => state.user);
    const {parentSite} = useSelector(state => state.site);
    const [showSubscribeField, setShowSubscribeField] = useState(false);
    const isMobile = useIsMobile();

    useEffect(() => {
        setShowSubscribeField(ipIsoCode !== 'us')
    }, [ipIsoCode])

    const openWindow = (url) => (event) => {
        event.preventDefault(); // Prevent the default behavior of the anchor tag
        window.open(`https://${url}`, isMobile ? 'terms' : '_blank', isMobile ? 'width: 50%' : 'noopener noreferrer');
    }

    return <FieldPrefix prefix="register">
        <div className="form-group">
            <div className="form-label">Email <span className="rq">*</span></div>
            <PrefixedField
                name="email"
                type="email"
                component={InputField}
                placeholder="e.g. Email@address.com"
                className="control-input auth-form-field"
                autoComplete="email"
                inputProps={{
                    inputMode: 'email',
                    autoCorrect: 'off',
                    spellCheck: 'false',
                    autoCapitalize: 'none',
                }}
                validate={composeValidators(
                    required('Please specify type email'),
                    email('Please provide a valid email'),
                    limit('Maximum {limit} characters allowed. You\'ve used {count}.', 320)
                )}
            />
            <PrefixedError name="email" />
        </div>
        <div className="form-group">
            <div className="form-label">Contact number <span className="rq">*</span></div>
            <PhoneFiled
                name="phone"
                options={countryOptions}
            />
        </div>
        {showSubscribeField && (
            <div className="form-group">
                <label className="checkbox-default">
                    <PrefixedField
                        name="subscribe"
                        type="checkbox"
                        component="input"
                    />
                    <span className="checkbox-default__checkmark">
                        <div className="checkbox-default__checkmark-icon">
                            <img src="/_core/assets/themes/v5/assets/img/form3/default-check-icon.svg" alt="" />
                        </div>
                    </span>
                    <p style={{margin: '2px 0 0px 0'}}>I want to receive news and special offers</p>
                </label>
            </div>
        )}
        <div className="form-text" style={{display: 'none'}}>
            <p>
                By signing in or creating an account, you agree with our <span> </span>
                <a onClick={openWindow(`${parentSite}/terms-conditions/`)} target="_blank" rel="noopener noreferrer">
                    Terms & Conditions
                </a>, <span> </span>
                <a onClick={openWindow(`${parentSite}/money-back/`)} target="_blank" rel="noopener noreferrer">
                    Money Back Guarantee
                </a>, <span> </span>
                <a onClick={openWindow(`${parentSite}/privacy-policy/`)} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a> and <span> </span>
                <a onClick={openWindow(`${parentSite}/cookie-policy/`)} target="_blank" rel="noopener noreferrer">
                    Cookie Policy
                </a>
            </p>
        </div>
    </FieldPrefix>
}

RegisterForm.propTypes = {
    countryOptions: PropTypes.array.isRequired,
}

export default RegisterForm;